module.exports = __webpack_public_path__ + "img/Bahnhof_Oravita_kl.9d90d287.jpg";